/**
 * Riot's "Riftbound Icons for Community Use" pack (assets/icons/*.png, copied from runebound.gg's
 * `public/icons`; research 06 §5.1). Imported as assets so the bundler fingerprints and serves them.
 * Never crop symbols from card images or take them from third-party sites.
 */
import battlefield from '../assets/icons/battlefield.png';
import body from '../assets/icons/body.png';
import body2 from '../assets/icons/body2.png';
import calm from '../assets/icons/calm.png';
import calm2 from '../assets/icons/calm2.png';
import championUnit from '../assets/icons/champion-unit.png';
import chaos from '../assets/icons/chaos.png';
import chaos2 from '../assets/icons/chaos2.png';
import common from '../assets/icons/common.png';
import epic from '../assets/icons/epic.png';
import fury from '../assets/icons/fury.png';
import fury2 from '../assets/icons/fury2.png';
import gear from '../assets/icons/gear.png';
import legend from '../assets/icons/legend.png';
import mind from '../assets/icons/mind.png';
import mind2 from '../assets/icons/mind2.png';
import order from '../assets/icons/order.png';
import order2 from '../assets/icons/order2.png';
import overnumbered from '../assets/icons/overnumbered.png';
import rainbowRuneOutline from '../assets/icons/rainbow-rune-outline.png';
import rainbowRune from '../assets/icons/rainbow-rune.png';
import rare from '../assets/icons/rare.png';
import rune from '../assets/icons/rune.png';
import spell from '../assets/icons/spell.png';
import sword from '../assets/icons/sword.png';
import tap from '../assets/icons/tap.png';
import uncommon from '../assets/icons/uncommon.png';
import unit from '../assets/icons/unit.png';

/** Icon URLs by name. */
export const ICONS = {
  battlefield,
  body,
  body2,
  calm,
  calm2,
  'champion-unit': championUnit,
  chaos,
  chaos2,
  common,
  epic,
  fury,
  fury2,
  gear,
  legend,
  mind,
  mind2,
  order,
  order2,
  overnumbered,
  'rainbow-rune': rainbowRune,
  'rainbow-rune-outline': rainbowRuneOutline,
  rare,
  rune,
  spell,
  sword,
  tap,
  uncommon,
  unit,
} as const;

export type IconName = keyof typeof ICONS;
